import React from 'react'
import styled from '@emotion/styled'

const Title = styled.h1`
  margin-bottom: 2rem;
`

const Section = styled.section`
  margin-bottom: 1.5rem;
`

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
      <Title>Privacy Policy</Title>
      <Section>
        <h2>1. Introduction</h2>
        <p>
          This Privacy Policy describes how we collect, use, and handle your personal information when you use our app. By using the app, you agree to the terms of this Privacy Policy. If you do not agree, please do not use the app.
        </p>
      </Section>
      
      <Section>
        <h2>2. Information We Collect</h2>
        <p>
          We collect the following types of information to provide and improve our services:
        </p>
        <ul>
          <li><strong>Personal Information:</strong> Name, email address, and any photos you upload to the app.</li>
          <li><strong>Usage Data:</strong> Information about how you use the app, such as your answers to the onboarding survey and interaction with app features.</li>
          <li><strong>Device Information:</strong> Details about the device you use, such as operating system and app version.</li>
        </ul>
      </Section>
      
      <Section>
        <h2>3. How We Use Your Information</h2>
        <p>
          We use the information we collect for the following purposes:
        </p>
        <ul>
          <li>To personalize your experience, including generating AI visualizations and fitness insights based on your inputs.</li>
          <li>To send you motivational notifications, reminders, and updates related to your fitness goals.</li>
          <li>To analyze app usage and improve functionality.</li>
          <li>To maintain the security and integrity of our app.</li>
        </ul>
      </Section>
      
      <Section>
        <h2>4. How We Share Your Information</h2>
        <p>
          We do not sell your personal information to third parties. We may share your information in the following cases:
        </p>
        <ul>
          <li>With trusted service providers who help us deliver and improve the app, subject to confidentiality agreements.</li>
          <li>To comply with legal obligations or protect the rights and safety of our users and others.</li>
        </ul>
      </Section>
      
      <Section>
        <h2>5. Data Retention</h2>
        <p>
          We retain your personal information as long as you maintain an account with us or as needed to provide you with the app's services. You can request the deletion of your data at any time.
        </p>
      </Section>
      
      <Section>
        <h2>6. Your Privacy Choices</h2>
        <p>
          You have the right to:
        </p>
        <ul>
          <li>Access, update, or delete your personal information.</li>
          <li>Withdraw consent for data processing where applicable.</li>
          <li>Disable notifications through app settings.</li>
        </ul>
        <p>
          To exercise these rights, contact us at co.enruta@gmail.com.
        </p>
      </Section>
      
      <Section>
        <h2>7. Security</h2>
        <p>
          We take reasonable measures to protect your personal information from unauthorized access, disclosure, or destruction. However, no system can guarantee absolute security.
        </p>
      </Section>
      
      <Section>
        <h2>8. Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. We will notify you of any significant changes by posting the updated policy within the app.
        </p>
      </Section>
      
      <Section>
        <h2>9. Contact Us</h2>
        <p>
          If you have any questions or concerns about this Privacy Policy, please contact us at co.enruta@gmail.com.
        </p>
      </Section>
    </div>
  )
}

export default PrivacyPolicy 